import React from 'react';
import PropTypes from 'prop-types';
import _ from 'underscore';

import Counter from '../../../Counter';
import { f$ } from '../../../../helpers/formatPrice';
import { modificationGroupProps } from '../../../../helpers/propTypes';

const TYPE_ONE_OF_MANY = 1;
const TYPE_MANY_OF_MANY = 2;

export default class DishGroup extends React.Component {
    static propTypes = {
      group: modificationGroupProps.isRequired,
      modification: PropTypes.arrayOf(
        PropTypes.shape({ m: PropTypes.number, a: PropTypes.number }),
      ).isRequired,
      onChange: PropTypes.func.isRequired,
      showCart: PropTypes.bool,
    };

    static defaultProps = {
      showCart: true,
    };

    getGroupModification = () => {
      const { group, modification } = this.props;

      // Выбираем модификации из этой группы
      return modification.filter((mod) => (
        _.findWhere(group.modifications, { dish_modification_id: mod.m })
      ));
    }

    changeValue = (e, dishModification) => {
      const { dish_modification_id: dishModificationId } = dishModification;
      const { onChange, group } = this.props;
      const { checked } = e.target;
      let selectedModifications = this.getGroupModification();

      const hasMod = _.findWhere(selectedModifications, { m: dishModificationId });
      if (!hasMod) {
        selectedModifications.push({ m: dishModificationId, a: 0, price: dishModification.price });
      }

      selectedModifications = selectedModifications.map((mod) => {
        if (mod.m === dishModificationId) {
          return { ...mod, a: checked ? 1 : 0 };
        }

        // Обнуляем остальные модификации если мы можем выбрать только одну
        if (group.type === TYPE_ONE_OF_MANY) {
          return { ...mod, a: 0 };
        }

        return mod;
      });

      onChange(selectedModifications);
    };

    render() {
      const {
        group, modification, onChange, showCart,
      } = this.props;
      let totalChecked = 0;
      this.getGroupModification().forEach((mod) => {
        totalChecked += mod.a;
      });
      let { modifications } = group;
      modifications = modifications.sort((a, b) => (a.dish_modification_id > b.dish_modification_id ? 1 : -1));

      return (
        <div className="p-dish-group mb-5">
          {modifications.map((item, index) => {
            const mod = modification.find((m) => m.m === item.dish_modification_id);
            const checked = Boolean(mod && mod.a);
            const lastInGroup = index === group.modifications.length - 1;

            return (
              <div className={`row g-3 border-light ${!lastInGroup && 'border-bottom'}`} key={item.dish_modification_id}>
                {showCart && (
                <div className="col-auto d-flex align-items-center">
                  <input
                    className="form-check-input p-3 mt-0"
                    id={item.dish_modification_id}
                    type={group.type === TYPE_MANY_OF_MANY ? 'checkbox' : 'radio'}
                    checked={checked}
                    disabled={group.type === TYPE_MANY_OF_MANY && group.num_max === totalChecked && !checked}
                    onChange={(e) => this.changeValue(e, item)}
                  />
                </div>
                )}
                <label className="col form-check-label py-4" htmlFor={item.dish_modification_id}>
                  <span>{item.name}</span>
                  {Boolean(item.price) && (
                    <span className="text-primary ms-0 ms-md-2 d-block d-md-inline-block">
                      {!item.hidePlus && '+'}
                      {f$(item.price)}
                    </span>
                  )}
                </label>
                {group.type === TYPE_MANY_OF_MANY && checked && (
                <div className="col-auto d-flex align-items-center">
                  <Counter
                    max={group.num_max - totalChecked + mod.a}
                    count={mod.a}
                    onChangeCount={(newCount) => onChange([{ ...mod, a: newCount }])}
                  />
                </div>
                )}
              </div>
            );
          })}
        </div>
      );
    }
}
